var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.288 20.375-6.563-5.325A9.062 9.062 0 0 0 18.6 9.538a8.96 8.96 0 0 0-2.663-6.413C12.413-.4 6.675-.4 3.114 3.125A8.993 8.993 0 0 0 .488 9.5a8.96 8.96 0 0 0 2.662 6.412 9.06 9.06 0 0 0 6.412 2.663 9.07 9.07 0 0 0 6.3-2.55l6.638 5.363c.113.112.262.15.413.15a.74.74 0 0 0 .524-.226c.188-.3.15-.712-.15-.937ZM4.05 15.012C2.588 13.55 1.8 11.6 1.8 9.5c0-2.1.787-4.012 2.288-5.475a7.72 7.72 0 0 1 5.474-2.25 7.72 7.72 0 0 1 5.476 2.25A7.72 7.72 0 0 1 17.325 9.5c0 2.063-.863 4.05-2.325 5.512-3 3-7.912 3-10.95 0Z",
    fill: "#163144"
  })));
};
export default SvgSearch;